<script>
import {
  createProductDeliveryExchangeTemplate,
  deleteProductDeliveryExchangeTemplateImage,
  deleteProductDeliveryExchangeTemplate,
  getProductDeliveryExchangeTemplates,
  updateProductDeliveryExchangeTemplate,
  uploadProductDeliveryExchangeTemplateImage,
} from '@/api/productDeliveryExchangeTemplate.js'
import { getBranchList } from '@/api/branch.js'

export default {
  name: 'ProductDeliveryExchangeTemplatePage',
  data() {
    return {
      keyword: '',
      scopeType: '',
      activeYn: 'Y',
      items: [],
      branchOptions: [{ title: '지점 선택', value: '' }],
      loading: false,
      dialog: false,
      saving: false,
      editingCode: '',
      form: this.emptyForm(),
      scopeOptions: [
        { title: '전체', value: '' },
        { title: '본사 공통', value: 'HEAD_OFFICE' },
        { title: '지점별', value: 'BRANCH' },
      ],
      activeOptions: [
        { title: '전체', value: '' },
        { title: '사용', value: 'Y' },
        { title: '미사용', value: 'N' },
      ],
    }
  },
  mounted() {
    Promise.all([this.fetchBranches(), this.fetchList()])
  },
  methods: {
    emptyForm() {
      return {
        templateName: '',
        scopeType: 'HEAD_OFFICE',
        branchCode: '',
        deliveryContent: '',
        exchangeContent: '',
        deliveryImages: [],
        exchangeImages: [],
        defaultYn: 'N',
        activeYn: 'Y',
        sortOrder: 0,
      }
    },
    async fetchBranches() {
      try {
        const res = await getBranchList({ page: 1, size: 100, activeYn: 'Y' })
        const items = res.data?.data?.items || res.data?.items || []
        this.branchOptions = [
          { title: '지점 선택', value: '' },
          ...items.map(item => ({ title: item.branchName || item.branchNm, value: item.branchCode })),
        ]
      } catch (error) {
        console.error('[ProductDeliveryExchangeTemplatePage] fetchBranches error:', error)
      }
    },
    async fetchList() {
      this.loading = true
      try {
        const res = await getProductDeliveryExchangeTemplates({
          keyword: this.keyword || undefined,
          scopeType: this.scopeType || undefined,
          activeYn: this.activeYn || undefined,
          page: 1,
          size: 100,
        })
        if (res.data?.code === 0) {
          this.items = res.data?.data?.items || res.data?.items || []
        }
      } finally {
        this.loading = false
      }
    },
    openCreate() {
      this.editingCode = ''
      this.form = this.emptyForm()
      this.dialog = true
    },
    openEdit(item) {
      this.editingCode = item.productDeliveryExchangeTemplateCode
      this.form = {
        templateName: item.templateName || '',
        scopeType: item.scopeType || 'HEAD_OFFICE',
        branchCode: item.branchCode || '',
        deliveryContent: item.deliveryContent || '',
        exchangeContent: item.exchangeContent || '',
        deliveryImages: item.deliveryImages || [],
        exchangeImages: item.exchangeImages || [],
        defaultYn: item.defaultYn || 'N',
        activeYn: item.activeYn || 'Y',
        sortOrder: item.sortOrder ?? 0,
      }
      this.dialog = true
    },
    validate() {
      if (!this.form.templateName?.trim()) return '템플릿명을 입력해주세요.'
      if (this.form.scopeType === 'BRANCH' && !this.form.branchCode) return '지점별 템플릿은 지점을 선택해야 합니다.'
      return ''
    },
    async save(closeDialog = true) {
      const message = this.validate()
      if (message) {
        window.alert(message)
        return false
      }
      this.saving = true
      try {
        const payload = {
          ...this.form,
          templateName: this.form.templateName.trim(),
          branchCode: this.form.scopeType === 'BRANCH' ? this.form.branchCode : null,
          sortOrder: Number(this.form.sortOrder || 0),
        }
        const res = this.editingCode
          ? await updateProductDeliveryExchangeTemplate(this.editingCode, payload)
          : await createProductDeliveryExchangeTemplate(payload)
        if (res.data?.code === 0) {
          const item = res.data.item
          if (item?.productDeliveryExchangeTemplateCode) {
            this.editingCode = item.productDeliveryExchangeTemplateCode
            this.form.deliveryImages = item.deliveryImages || []
            this.form.exchangeImages = item.exchangeImages || []
          }
          if (closeDialog) this.dialog = false
          await this.fetchList()
          return true
        } else {
          window.alert(res.data?.message || '저장 중 오류가 발생했습니다.')
          return false
        }
      } catch (error) {
        window.alert(error?.response?.data?.message || '저장 중 오류가 발생했습니다.')
        return false
      } finally {
        this.saving = false
      }
    },
    async remove(item) {
      if (!window.confirm(`${item.templateName} 템플릿을 미사용 처리할까요?`)) return
      const res = await deleteProductDeliveryExchangeTemplate(item.productDeliveryExchangeTemplateCode)
      if (res.data?.code === 0) await this.fetchList()
    },
    async uploadImage(imageType, event) {
      const file = event.target.files?.[0]
      event.target.value = ''
      if (!file) return
      if (!this.editingCode) {
        const saved = await this.save(false)
        if (!saved || !this.editingCode) return
      }
      this.saving = true
      try {
        const res = await uploadProductDeliveryExchangeTemplateImage(this.editingCode, imageType, file)
        if (res.data?.code === 0) {
          const item = res.data.item
          this.form.deliveryImages = item?.deliveryImages || []
          this.form.exchangeImages = item?.exchangeImages || []
          await this.fetchList()
        } else {
          window.alert(res.data?.message || '이미지 업로드 중 오류가 발생했습니다.')
        }
      } catch (error) {
        window.alert(error?.response?.data?.message || '이미지 업로드 중 오류가 발생했습니다.')
      } finally {
        this.saving = false
      }
    },
    async deleteImage(image) {
      if (!this.editingCode || !image?.productDeliveryExchangeTemplateImageCode) return
      if (!window.confirm('이미지를 삭제하시겠습니까?')) return
      this.saving = true
      try {
        const res = await deleteProductDeliveryExchangeTemplateImage(
          this.editingCode,
          image.productDeliveryExchangeTemplateImageCode,
        )
        if (res.data?.code === 0) {
          const item = res.data.item
          this.form.deliveryImages = item?.deliveryImages || []
          this.form.exchangeImages = item?.exchangeImages || []
          await this.fetchList()
        } else {
          window.alert(res.data?.message || '이미지 삭제 중 오류가 발생했습니다.')
        }
      } finally {
        this.saving = false
      }
    },
    scopeText(value) {
      return value === 'BRANCH' ? '지점별' : '본사 공통'
    },
  },
}
</script>

<template>
  <div>
    <div class="d-flex align-center justify-space-between mb-5">
      <div>
        <div class="text-h5 font-weight-bold">배송/교환 안내 관리</div>
        <div class="text-body-2 text-grey mt-1">상품 상세에 노출할 배송 및 교환/반품 안내 템플릿을 관리합니다.</div>
      </div>
      <v-btn color="primary" prepend-icon="mdi-plus" @click="openCreate">템플릿 등록</v-btn>
    </div>

    <v-card rounded="lg" elevation="1" class="mb-5">
      <v-card-text>
        <v-row align="center">
          <v-col cols="12" md="5">
            <v-text-field v-model="keyword" label="검색" variant="outlined" density="compact" hide-details clearable @keyup.enter="fetchList" />
          </v-col>
          <v-col cols="12" md="2">
            <v-select v-model="scopeType" :items="scopeOptions" label="범위" variant="outlined" density="compact" hide-details />
          </v-col>
          <v-col cols="12" md="2">
            <v-select v-model="activeYn" :items="activeOptions" label="사용여부" variant="outlined" density="compact" hide-details />
          </v-col>
          <v-col cols="12" md="3" class="d-flex justify-end ga-2">
            <v-btn color="primary" prepend-icon="mdi-magnify" @click="fetchList">검색</v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-card rounded="lg" elevation="1">
      <v-progress-linear v-if="loading" indeterminate color="primary" />
      <v-table>
        <thead>
          <tr>
            <th>템플릿명</th>
            <th>범위</th>
            <th>지점</th>
            <th>기본</th>
            <th>사용</th>
            <th>정렬</th>
            <th class="text-center">관리</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in items" :key="item.productDeliveryExchangeTemplateCode">
            <td class="font-weight-bold">{{ item.templateName }}</td>
            <td>{{ scopeText(item.scopeType) }}</td>
            <td>{{ item.branchName || '-' }}</td>
            <td>{{ item.defaultYn }}</td>
            <td>{{ item.activeYn }}</td>
            <td>{{ item.sortOrder }}</td>
            <td class="text-center">
              <v-btn size="small" variant="text" icon="mdi-pencil" @click="openEdit(item)" />
              <v-btn size="small" variant="text" icon="mdi-delete" color="error" @click="remove(item)" />
            </td>
          </tr>
          <tr v-if="!loading && !items.length">
            <td colspan="7" class="text-center py-8 text-grey">등록된 템플릿이 없습니다.</td>
          </tr>
        </tbody>
      </v-table>
    </v-card>

    <v-dialog v-model="dialog" max-width="820">
      <v-card rounded="lg">
        <v-card-title>{{ editingCode ? '템플릿 수정' : '템플릿 등록' }}</v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" md="6"><v-text-field v-model="form.templateName" label="템플릿명 *" variant="outlined" /></v-col>
            <v-col cols="12" md="3"><v-select v-model="form.scopeType" :items="scopeOptions.filter(item => item.value)" label="범위 *" variant="outlined" /></v-col>
            <v-col cols="12" md="3">
              <v-select v-model="form.branchCode" :items="branchOptions" label="지점" variant="outlined" :disabled="form.scopeType !== 'BRANCH'" />
            </v-col>
            <v-col cols="12" md="4"><v-text-field v-model.number="form.sortOrder" type="number" label="정렬순서" variant="outlined" /></v-col>
            <v-col cols="12" md="4"><v-switch v-model="form.defaultYn" true-value="Y" false-value="N" color="primary" label="기본 템플릿" /></v-col>
            <v-col cols="12" md="4"><v-switch v-model="form.activeYn" true-value="Y" false-value="N" color="primary" label="사용 여부" /></v-col>
            <v-col cols="12"><v-textarea v-model="form.deliveryContent" label="배송 안내" variant="outlined" rows="6" auto-grow /></v-col>
            <v-col cols="12">
              <div class="image-block">
                <div class="d-flex align-center justify-space-between mb-3">
                  <div class="font-weight-bold">배송 안내 이미지</div>
                  <input ref="deliveryImageInput" type="file" accept="image/jpeg,image/png,image/gif,image/webp,.jpg,.jpeg,.png,.gif,.webp" hidden @change="uploadImage('DELIVERY', $event)">
                  <v-btn size="small" variant="tonal" prepend-icon="mdi-image-plus" :disabled="saving" @click="$refs.deliveryImageInput?.click()">이미지 등록</v-btn>
                </div>
                <div class="image-list">
                  <div v-for="image in form.deliveryImages" :key="image.productDeliveryExchangeTemplateImageCode" class="image-item">
                    <v-img :src="image.imageUrl" width="120" height="120" cover rounded="lg" />
                    <v-btn icon size="x-small" color="error" class="image-delete" @click="deleteImage(image)"><v-icon>mdi-close</v-icon></v-btn>
                  </div>
                  <span v-if="!form.deliveryImages?.length" class="text-caption text-grey">등록된 이미지가 없습니다.</span>
                </div>
              </div>
            </v-col>
            <v-col cols="12"><v-textarea v-model="form.exchangeContent" label="교환/반품 안내" variant="outlined" rows="6" auto-grow /></v-col>
            <v-col cols="12">
              <div class="image-block">
                <div class="d-flex align-center justify-space-between mb-3">
                  <div class="font-weight-bold">교환/반품 안내 이미지</div>
                  <input ref="exchangeImageInput" type="file" accept="image/jpeg,image/png,image/gif,image/webp,.jpg,.jpeg,.png,.gif,.webp" hidden @change="uploadImage('EXCHANGE', $event)">
                  <v-btn size="small" variant="tonal" prepend-icon="mdi-image-plus" :disabled="saving" @click="$refs.exchangeImageInput?.click()">이미지 등록</v-btn>
                </div>
                <div class="image-list">
                  <div v-for="image in form.exchangeImages" :key="image.productDeliveryExchangeTemplateImageCode" class="image-item">
                    <v-img :src="image.imageUrl" width="120" height="120" cover rounded="lg" />
                    <v-btn icon size="x-small" color="error" class="image-delete" @click="deleteImage(image)"><v-icon>mdi-close</v-icon></v-btn>
                  </div>
                  <span v-if="!form.exchangeImages?.length" class="text-caption text-grey">등록된 이미지가 없습니다.</span>
                </div>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn variant="text" @click="dialog = false">취소</v-btn>
          <v-btn color="primary" :loading="saving" @click="save">저장</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<style scoped>
.image-block {
  border: 1px solid rgba(var(--v-border-color), var(--v-border-opacity));
  border-radius: 8px;
  padding: 16px;
  background: rgba(255, 255, 255, 0.02);
}

.image-list {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: center;
  min-height: 40px;
}

.image-item {
  position: relative;
  width: 120px;
  height: 120px;
}

.image-delete {
  position: absolute;
  top: 6px;
  right: 6px;
}
</style>
